// extracted by mini-css-extract-plugin
module.exports = {"recommendedCarousel":"recommendedCarousel__FnGeo"};